import { Component, OnInit, ViewEncapsulation, ElementRef, ViewChildren, QueryList } from '@angular/core';
import { DashboardService } from './dashboard.service';
import { Router } from '@angular/router';
import { BaseChartDirective } from 'ng2-charts/ng2-charts';
declare var Core: any;
declare var $: any;
@Component({
  moduleId: module.id,
  templateUrl: './dashboard.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  @ViewChildren(BaseChartDirective) charts: QueryList<BaseChartDirective>;
  userData: any;
  controlgroup: any;
  UserType: any;
  sourceData: any;
  tabelData: any;
  dataLoaded: boolean = false;
  topScrollWidth: any;
  taxYearData: any;
  selectedTaxYear: any = '';
  firstyear = "2021";
  productionArray: any = [];
  showsDataArray: any = [];
  sourceDataArray: any = [];
  currentPage: 1;
  showControlGropData: boolean;
  controlgroupDataArray: any = [];
  
  public barChartOptions: any = {
    responsive: true,

    // We use these empty structures as placeholders for dynamic theming.
    scales: {
      xAxes: [{}],
      yAxes: [{}]
    },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
      }
    }
  };
  public barChartLabels: any[] = [];
  public barChartType: string = 'bar';
  public barChartLegend = true;

  public barChartData: Array<any> = [];
  public barChartColors: any[] = [
    { backgroundColor: '#3478b5' }
  ];
  // line chart
  public lineChartData: Array<any> = [];
  public lineChartLabels: any[] = [];
  public lineChartOptions: (any & { annotation: any }) = {
    responsive: true,
    scales: {
      // We use this empty structure as a placeholder for dynamic theming.
      xAxes: [{}],
      yAxes: [{
        ticks: {
            
        }
    }]
    },
    annotation: {
      annotations: [
        {
          type: 'line',
          mode: 'vertical',
          scaleID: 'x-axis-0',
          value: 'March',
          borderColor: 'orange',
          borderWidth: 1,
          label: {
            enabled: true,
            fontColor: 'orange',
            content: 'LineAnno'
          }
        },
      ],
    },
  };
  public lineChartColors: any[] = [
    { // grey
      backgroundColor: 'rgba(52,120,181,0.2)',
      borderColor: '#3478b5',
      pointBackgroundColor: '#3478b5',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: '#3478b5'
    },
    { // dark grey
      backgroundColor: 'rgba(209,109,63,0.2)',
      borderColor: '#d16d3f',
      pointBackgroundColor: '#d16d3f',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: '#d16d3f'
    },
    { // blue
      backgroundColor: 'rgba(0,0,255,0.3)',
      borderColor: '#e1e1e1',
      pointBackgroundColor: 'rgba(0,0,255,0.3)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(0,0,255,0.3)'
    }
  ];
  public lineChartLegend = true;
  public lineChartType: String = 'line';

  popupData:any = [];
  popupHeading:any;
  revToggleStatus:boolean = false;
  genericCount:any = {};
  accountingCount:any = {};
  mostRecentActiveShows:any = [];
  erSizeTotalCount:any = 0;
  sources: any = [];
  selectedSource: any = '';
  defaultLabels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  defaultData = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  downloadingPDF = false;
  selectedCg:any;
  constructor(public service: DashboardService, public route: Router) {
    this.userData = JSON.parse(localStorage.getItem('token'));
    this.controlgroup = this.userData.principal.controlGroups;
    this.UserType = this.userData.principal.roles[0];
  }
  ngOnInit() {
    this.taxyearInfo();
    this.loadDefaultCharts()
    this.selectedCg = this.controlgroup[0];
  }

  taxyearInfo() {
   let data = {
      userType: this.userData.principal.roles[0],
      controlGroup:this.userData.principal.roles[0] == 'User' ? this.userData.principal.controlGroups : []
  }
    this.service.getTaxyears(data).subscribe((res: any) => {
      this.taxYearData = res.taxYear;
      this.selectedTaxYear = this.taxYearData[0];
      this.sources = res.sources;
      this.getChartsData();
      this.getGeneralCount();
    })
  }
  getFilterData(type:any,value:any) {
    switch(type) {
      case 'source':
        this.selectedSource = value || ''
        break;
      case 'year':
        this.selectedTaxYear = value || this.taxYearData[0];
        break;
      case 'cg':
        this.selectedCg = value || this.controlgroup[0];
        break;
    }
      this.getGeneralCount();
      this.getChartsData();
  }
  changePage = (index: any) => {
    this.currentPage = index;
  };
  openemployeesearch() {
    this.route.navigate(['reporting/employeedetails'], { replaceUrl: true });
  }
  gotoshows() {
    this.route.navigate(['reporting/shownames'], { replaceUrl: true });
  }
 
   
  
  gotonoofvendors() {
    this.route.navigate(['reporting/costanalysisvendor'], { replaceUrl: true });
  }
  gotototalcose() {
    this.route.navigate(['reporting/costanalysisshow'], { replaceUrl: true });
  }

  // events
  public chartClicked({ event, active }: { event: MouseEvent, active: {}[] }): void {
    console.log(event, active);
  }

  public chartHovered({ event, active }: { event: MouseEvent, active: {}[] }): void {
    console.log(event, active);
  }

  toggleGeneralData(event:any){
    this.getGeneralCount();
  }

  getGeneralCount(){
    let data = {
      userType: this.UserType,
      controlGroup:((this.UserType == 'User' && this.userData.principal.controlGroups.length > 1) && this.userData.principal.isRev != 'Y') ? [this.selectedCg] : this.controlgroup,
      taxYear: this.selectedTaxYear ? this.selectedTaxYear : this.taxYearData[0],
      source: this.selectedSource,
      isRev: this.userData.principal.isRev
    }
    this.service.getFilterData(data).subscribe((res: any) => {
      this.genericCount = res.count[0] ? res.count[0] : {}
      this.accountingCount = res.accountingVo?res.accountingVo[0]:{}
      this.mostRecentActiveShows = res.mostRecentActiveShows || []
    })
    
  }

  getChartsData(){
    if(this.UserType == 'User' && this.userData.principal.isRev != 'Y'){

    const cg = (this.UserType == 'User' && this.userData.principal.controlGroups.length > 1) ? this.selectedCg : this.controlgroup

    this.service.getChartsData(cg, (this.selectedTaxYear ? this.selectedTaxYear : this.taxYearData[0])).subscribe((res: any) => {
      
      this.erSizeTotalCount = res.erSizeTotalCount || 0

      if(res.graphCount){
        let { employerSize, employerSizePartTime, newHireFullTime, employeeNewhire} = res.graphCount;

        this.barChartData = [], this.lineChartData = []
  
        this.barChartLabels = employerSize.map((ele:any) => ele.month);
  
        this.lineChartLabels = newHireFullTime.map((ele:any) => ele.month);
        
        let employerSizeData = employerSize.map((ele:any) => ele.count);
  
        let employerSizePartTimeData = employerSizePartTime.map((ele:any) => ele.count);
  
        let newHireFullTimeData = newHireFullTime.map((ele:any) => ele.count);
  
        let employeeNewhireData = employeeNewhire.map((ele:any) => ele.count);
  
        this.barChartData.push({data:employerSizeData,label: 'Full-time Employees'})
        this.barChartData.push({data:employerSizePartTimeData,label: 'Part-time Employees'})
  
        this.lineChartData.push({data:employeeNewhireData,label: 'All New Hires'})
        this.lineChartData.push({data:newHireFullTimeData,label: 'Full-time New Hires'})
  
        
        this.charts.forEach((child) => {
          if(child.chart.config.type == 'bar'){
            child.chart.data.datasets[0].data = employerSizeData
            child.chart.data.datasets[1].data = employerSizePartTimeData
            child.chart.labels = this.barChartLabels
            child.chart.data.labels = this.barChartLabels
          }else{
            child.chart.data.datasets[0].data = employeeNewhireData
            child.chart.data.datasets[1].data = newHireFullTimeData
            child.chart.labels = this.lineChartLabels
            child.chart.data.labels = this.lineChartLabels
          }
          child.chart.update()
      });
      }
    })
   }
  }
  loadDefaultCharts(){
    this.barChartLabels = this.defaultLabels, this.lineChartLabels = this.defaultLabels
    this.barChartData.push({data:this.defaultData,label: 'Full-time Employees'})
    this.barChartData.push({data:this.defaultData,label: 'Part-time Employees'})
    this.lineChartData.push({data:this.defaultData,label: 'All New Hires'})
    this.lineChartData.push({data:this.defaultData,label: 'Full-time New Hires'})
  }

  getPopupColor(value:any){
    switch (value) {
      case 'PAYROLL SOURCES':
        return {'background-color':'#74F1D1'}
      case 'CONTROLLED GROUPS':
        return {'background-color':'#E7AF4F'}
      case 'PRODUCTION COMPANIES':
        return {'background-color':'#3699F0'}
      case 'SHOWS':
        return {'background-color':'#D496EB'}
    }
  }
  onClickPDF(cg:any){
    this.downloadingPDF = true
    this.service.downloadPDF(this.selectedTaxYear,cg).subscribe((res: any) => {
      this.downloadingPDF = false;
    }, (err: any) => (this.downloadingPDF = false));
  }

  getProductData(type:any){
      this.popupData = [];
      this.currentPage = 1;
      let cgs = (this.UserType == 'User' && this.userData.principal.controlGroups.length > 1) && this.userData.principal.isRev != 'Y' ? [this.selectedCg] : this.controlgroup
      this.service.getProductionData(
         {
          userType: this.UserType,
          controlGroup: cgs,
          taxYear: this.selectedTaxYear,
          searchKey: type,
          source: this.selectedSource
        } 
      ).subscribe((res: any) => {
        switch(type) {
          case 'sources':
            this.popupData = res.sources || [];
            this.popupHeading = 'PAYROLL SOURCES';
            break;
          case 'productionCompanies':
            this.popupData = res.productionCompanies || [];
            this.popupHeading = 'PRODUCTION COMPANIES';
            break;
          case 'controlGroups':
            this.popupData = res.controlGroups || [];
            this.popupHeading = 'CONTROLLED GROUPS'
            break;
          case 'shows':
            this.popupData = res.shows || [];
            this.popupHeading = 'SHOWS'
            break;
        }
        $('#popModal').modal('show');
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts